<script setup>
import MixedGridFilters from '../mixedGrid/MixedGridFilters.vue';
import { computed, inject, provide, ref } from 'vue';
import { DEFAULT_SORT, getFilterById } from '@phoenix/helpers/mixed-grid-helper';

const props = defineProps({
  uniqueId: {
    type: String,
    required: true,
  },
  filters: {
    type: Array,
    required: true,
  },
  panelId: {
    type: String,
    default: 'filters-panel',
  },
  isDarkMode: {
    type: Boolean,
    default: false,
  },
  hasFiltersInUrl: {
    type: Boolean,
    default: false,
  },
  productsCount: {
    type: Number,
    default: 0,
  },
  shouldDisplayProductsCount: {
    type: Boolean,
    default: true,
  },
  cta: {
    type: Object,
    default: null,
  },
});

const reversoFilterId = inject('reversoFilterId', '');

const emit = defineEmits(['onSortChanged', 'onFiltersChanged', 'filtersInitialized']);

const defaultSort = DEFAULT_SORT;
const sellableFilterId = `sellable--${window.Phoenix.currentCountry}`;
const mixedGridFiltersRef = ref(null);

const shouldDisplayFilters = computed(() => props.filters.length > 0);

const shouldDisplaySellable = computed(
  () => props.filters.find((filter) => filter.id === sellableFilterId) !== undefined,
);

const displayedFilters = computed(() => props.filters.filter((filter) => filter.id !== sellableFilterId));

const reversoAllCounts = computed(() => {
  const filter = getFilterById(props.filters, reversoFilterId);

  return filter ? filter.items.reduce((carry, item) => carry + item.count, 0) : 0;
});

const toggleFilter = (filterId, value) => {
  mixedGridFiltersRef.value.toggleFilter(filterId, value);
};

defineExpose({ toggleFilter });
provide('reversoAllCounts', reversoAllCounts);
</script>

<template>
  <mixed-grid-filters
    v-if="shouldDisplayFilters"
    ref="mixedGridFiltersRef"
    :unique-id="uniqueId"
    :filters="displayedFilters"
    :default-sort="defaultSort"
    :panel-id="panelId"
    :is-dark-mode="isDarkMode"
    :has-filters-in-url="hasFiltersInUrl"
    :products-count="productsCount"
    :should-display-products-count="shouldDisplayProductsCount"
    :should-display-sellable="shouldDisplaySellable"
    :cta="cta"
    :sellable-filter-id="sellableFilterId"
    @on-sort-change="emit('onSortChanged', $event)"
    @on-filters-changed="emit('onFiltersChanged', $event)"
    @filters-initialized="emit('filtersInitialized', $event)"
  />
</template>
